// @flow
import React, {type Node, Fragment} from 'react'
import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'

import ItemsSection from 'components/SideBar/ui/ItemsSection'
import SectionItem from 'components/SideBar/ui/SectionItem'

import AdminLinks from './AdminLinks'
import type {
  AdminSection_organization as Organization,
} from './__generated__/AdminSection_organization.graphql'

type Props = $ReadOnly<{
  organization: Organization,
}>

function AdminSection({organization}: Props): Node {
  const adminLinks = new AdminLinks(organization)
  const onRestrictedPlan = organization.onRestrictedPlan

  const adminItems = () => adminLinks.sectionAdminItems
  const superAdminItems = () => adminLinks.sectionSuperAdminItems

  return (
    <div className="admin-section">
      <ItemsSection
        title={I18n.t('side_nav.admin.title')}
        sectionName="admin-sections"
        collapsibleSection
        renderChildren={() => (
          <Fragment>
            {adminItems().map((item) => (
              <SectionItem
                {...item}
                key={item.href}
                premiumCallout={onRestrictedPlan ? item.premiumCallout : null}
              />
            ))}
          </Fragment>
        )}
      />
      {organization.viewerIsSuperUser && (
        <ItemsSection
          title={I18n.t('side_nav.super_admin.title')}
          sectionName="admin-sections"
          collapsibleSection
          renderChildren={() => (
            <Fragment>
              {superAdminItems().map((item) => (
                <SectionItem
                  {...item}
                  key={item.href}
                />
              ))}
            </Fragment>
          )}
        />
      )}
    </div>
  )
}

export default (createFragmentContainer(AdminSection, {
  organization: graphql`
    fragment AdminSection_organization on Organization {
      viewerIsSuperUser
      onRestrictedPlan

      viewer {
        routes {
          adminOrganizationPeoplePath
          adminOrganizationGlobalItemsPath
          adminOrganizationHabitsPath
          editAccountPath
          editAdminOrganizationPath
          adminBannerNoticesPath
          adminLessonsPath
          adminOfficeHoursPath
          adminOrganizationsPath
          adminReportsPath
          adminSearchOrganizationPath
          adminSearchPeoplePath
          announcementsPath
          deactivatedAdminOrganizationsPath
          metricsSummaryAdminOrganizationsPath
          newAdminOrganizationPath
          newImpersonationPath
          adminAiContentEditPath
        }
      }
    }
  `,
}): RelayFragmentContainer<typeof(AdminSection)>)
